import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from '../styles/AmbientHints.module.css';
import { PageTitle, PageTitleContainer } from '../styles/AmbientHintsStyle';
import productsData from '../data/products.json';
import iconFilter from '../imgs/filtro.png';
import {
  BtnPedirOrc,
  MainContainerWithFilter,
  MainProductsContainer,
  ProductItem, 
} from '../styles/ProductsContainerStyle';

import AddToWishlist from './AddToWishList';
import Filter from './Filter';

const ProductsContainer = () => {
  const { categoryId, subcategoryId, subsub, ambientGuide } = useParams();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showFilter, setShowFilter] = useState(false); 
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    try {
      setProducts(productsData.products);
      setLoading(false);
    } catch (err) {
      console.error('Erro ao carregar os produtos:', err);
      setError('Não foi possível carregar os produtos.');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const filteredProducts = products.filter((product) => {
    const matchesCategory = categoryId ? product.category === categoryId : true;
    const matchesSubcategory = subcategoryId
      ? product.subcategory === subcategoryId
      : true;
    const matchesSubsub = subsub
      ? product.subCategoryFilter === subsub
      : true;
    const matchesAmbientGuide = ambientGuide
      ? product.ambientGuide === ambientGuide
      : true;
  
    return matchesCategory && matchesSubcategory && matchesSubsub && matchesAmbientGuide;
  });

  const handlePedirOrcamentoClick = (product) => {
    navigate(`/product-detail/${product.id}`, { state: { product } });
  };

  if (loading) return <p>Carregando produtos...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className={styles.container}>
      <PageTitleContainer>
        <PageTitle>
          <PageTitle>
            {subcategoryId
              ? subcategoryId
              : categoryId
                ? categoryId
                : ambientGuide
                  ? ambientGuide
                  : 'Todos os Produtos'}
          </PageTitle>
        </PageTitle>
        
        {isMobile && (
          <img
            src={iconFilter}
            height={32}
            width={32}
            alt="Ícone de Filtro"
            onClick={() => setShowFilter((prevState) => !prevState)} 
            style={{ cursor: 'pointer' }}
          />
        )}
      </PageTitleContainer>

      <MainContainerWithFilter>
        {(!isMobile || showFilter) && <Filter />}
        <MainProductsContainer>
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <ProductItem key={product.id}>
                <img
                  src={product.image_1}
                  alt={product.name}
                  onClick={() => handlePedirOrcamentoClick(product)}
                />
                <p style={{ fontSize: 18, marginBottom: 12 }}>{product.name?.toUpperCase() ?? ""}</p>
                <div className="btn-container">
                  <BtnPedirOrc onClick={() => handlePedirOrcamentoClick(product)}>
                    Pedir Orçamento
                  </BtnPedirOrc>
                </div>
                <AddToWishlist product={product} />
              </ProductItem>
            ))
          ) : (
            <p>Nenhum produto encontrado para esta categoria.</p>
          )}
        </MainProductsContainer>
      </MainContainerWithFilter>
    </div>
  );
};

export default ProductsContainer;
